/**
 * Link to take the user back to where they came from.
 */

import {MOON_600, MOON_800} from '@wandb/weave/common/css/globals.styles';
import {IconBack} from '@wandb/weave/components/Icon';
import React from 'react';
import {Link, useLocation} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export type LocationState = {
  from?: {
    url: string;
    text: string;
  };
};

const BackLinkContent = styled.span`
  color: ${MOON_600};
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  &:hover {
    color: ${MOON_800};
  }
`;
BackLinkContent.displayName = 'S.BackLinkContent';

const BackArrow = styled(IconBack)`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
BackArrow.displayName = 'S.BackArrow';

type BackLinkProps = {
  // By default, if there is no previous page this component will not render.
  // Caller can specify these to override this behavior.
  to?: string;
  text?: string;
  'data-test'?: string;
};

export const BackLink = ({to, text, 'data-test': dataTest}: BackLinkProps) => {
  const {state} = useLocation<LocationState>();
  const resolvedTo = state?.from?.url ?? to;
  const resolvedText = state?.from?.text ?? text;
  if (!resolvedTo || !resolvedText) {
    return null;
  }

  return (
    <Link to={resolvedTo}>
      <BackLinkContent data-test={dataTest}>
        <BackArrow />
        {resolvedText}
      </BackLinkContent>
    </Link>
  );
};
